/* 3D képkeret: főoldali konfigurátor (minta grafika, keretszín, méret, tájolás, elhelyezés).
 * A szekció <kk3d-hero> elemét vezérli: betöltés előtt az adatattribútumait állítja, utána a futó modellt (hero.ctl.set).
 * Minden mintánál a hozzá rendelt termék variánsaiból számolja, mely keret és méret kombináció rendelhető,
 * és a „rendelés” gomb a kiválasztott variánsra mutat. */
(() => {
  if (window.KK3DCfg) return;
  const RULES = [[/fehér/i, 'white'], [/fekete/i, 'black'], [/nyír/i, 'birch'], [/tölgy/i, 'oak'], [/arany/i, 'gold'], [/ezüst/i, 'silver']];
  const COLORS = ['white', 'black', 'birch', 'oak', 'gold', 'silver'];
  const SIZES = ['13x18', '21x30', '30x40'];
  const LABELS = { color: { white:'Fehér', black:'Fekete', birch:'Nyír hatású', oak:'Tölgy hatású', gold:'Arany', silver:'Ezüst' } };

  function parse(opts){
    let color = null, size = null;
    for (const raw of opts || []){
      const v = String(raw || '');
      if (!color && /képkeret/i.test(v)) for (const [re, k] of RULES) if (re.test(v)){ color = k; break; }
      const m = [...v.matchAll(/(\d{2})\s*[x×]\s*(\d{2})/gi)].pop();
      if (m){ const a = +m[1], b = +m[2], k = `${Math.min(a, b)}x${Math.max(a, b)}`; if (SIZES.includes(k)) size = k; }
    }
    return color && size ? { color, size } : null;
  }
  /* szín -> méret -> variáns azonosító; null, ha a mintához nincs termék (ilyenkor minden kombináció választható) */
  function availOf(g){
    const ids = Object.keys(g.variants || {}); if (!ids.length) return null;
    const a = {};
    for (const id of ids){ const p = parse(g.variants[id]); if (!p) continue; a[p.color] ||= {}; if (!a[p.color][p.size]) a[p.color][p.size] = id; }
    return Object.keys(a).length ? a : null;
  }

  function init(panel){
    if (panel._kk3d) return; panel._kk3d = true;
    const hero = panel.closest('section')?.querySelector('kk3d-hero'); if (!hero) return;
    let data; try { data = JSON.parse(panel.querySelector('[data-kk3d-cfg-data]').textContent); } catch { return; }
    const G = (data.graphics || []).map(g => ({ ...g, avail: availOf(g) }));
    const d = hero.dataset;
    const st = { g:0, color: COLORS.includes(d.color) ? d.color : 'oak', size: SIZES.includes(d.size) ? d.size : '21x30',
                 orient: d.orient === 'landscape' || d.orient === 'portrait' ? d.orient : null, mode: d.mode === 'wall' ? 'wall' : 'table' };
    const gr = () => G[st.g] || null;
    const has = (g, o) => !!(g && g[o === 'landscape' ? 'land' : 'port']);

    function normalize(){
      const g = gr(), av = g && g.avail;
      if (av){
        if (!av[st.color]) st.color = COLORS.find(c => av[c]) || st.color;
        const sz = av[st.color] || {};
        if (!sz[st.size]) st.size = ['21x30', '30x40', '13x18'].find(s => sz[s]) || st.size;
      }
      if (g){
        if (st.orient === 'landscape' && !has(g, 'landscape')) st.orient = 'portrait';
        else if (st.orient === 'portrait' && !has(g, 'portrait')) st.orient = 'landscape';
        else if (!st.orient) st.orient = has(g, 'portrait') ? 'portrait' : 'landscape';
      } else if (!st.orient) st.orient = 'portrait';
      if (st.size === '30x40') st.mode = 'wall';   // a 30×40-nek nincs talpa
    }
    const imgFor = () => { const g = gr(); return g ? (st.orient === 'landscape' ? g.land : g.port) || g.land || g.port : (d.image || null); };

    function sync(){
      const g = gr(), av = g && g.avail;
      // ha a minta csak egy tájolásban készül, a választó helyett egy rögzített jelölés látszik
      const fixedOrient = !!g && !(has(g, 'portrait') && has(g, 'landscape'));
      panel.querySelectorAll('[data-opt]').forEach(b => {
        const o = b.dataset.opt, v = b.dataset.val; let on = false, dis = false;
        if (o === 'g') on = +v === st.g;
        else if (o === 'color'){ on = v === st.color; dis = !!av && !av[v]; }
        else if (o === 'size'){ on = v === st.size; dis = !!av && !(av[st.color] || {})[v]; }
        else if (o === 'orient'){
          on = v === st.orient;
          b.hidden = fixedOrient && !on;
          b.style.pointerEvents = fixedOrient ? 'none' : '';
          b.title = fixedOrient ? 'Ez a minta ebben a tájolásban készül' : '';
          dis = !fixedOrient && !!g && !has(g, v);
        }
        else if (o === 'mode'){ on = v === st.mode; dis = v === 'table' && st.size === '30x40'; }
        b.setAttribute('aria-pressed', String(on)); b.disabled = dis;
      });
      panel.querySelectorAll('[data-kk3d-val]').forEach(el => {
        const k = el.dataset.kk3dVal;
        el.textContent = k === 'g' ? (g ? g.label : '') : ((LABELS[k] || {})[st[k]] || '');
      });
      const cta = panel.querySelector('[data-kk3d-cfg-cta]');
      if (cta){
        const vid = av && (av[st.color] || {})[st.size];
        if (g && g.url){ cta.href = g.url + (vid ? (g.url.includes('?') ? '&' : '?') + 'variant=' + vid : ''); cta.hidden = false; }
        else cta.hidden = true;
      }
    }

    let lastImg = null, lastSize = null, pending = false, queue = Promise.resolve();
    function push(force){
      const img = imgFor();
      Object.assign(d, { size: st.size, color: st.color, orient: st.orient, mode: st.mode });
      if (img) d.image = img;
      const ctl = hero.ctl;
      if (!ctl){ pending = true; lastImg = img; lastSize = st.size; return; }   // a 3D még nem töltött be: a betöltés az adatattribútumokból indul
      const p = { size: st.size, color: st.color, orient: st.orient, mode: st.mode };
      if (force || img !== lastImg){ p.image = img; lastImg = img; }
      const resize = force || st.size !== lastSize; lastSize = st.size;
      hero.classList.add('is-loading');
      queue = queue.then(() => ctl.set(p)).then(() => {
        if (resize){ const sp = ctl.isSpinning(); ctl.goView('threeq'); if (sp) ctl.setSpin(true); }   // méretváltáskor a kamera is igazodjon
      }).catch(e => console.warn('[KK 3D]', e)).finally(() => hero.classList.remove('is-loading'));
    }
    // ha a betöltés közben választottak, a kész modellt egyszer frissítjük
    const watch = setInterval(() => { if (!hero.isConnected) return clearInterval(watch); if (hero.ctl){ clearInterval(watch); if (pending){ pending = false; push(true); } } }, 300);

    panel.addEventListener('click', e => {
      const b = e.target.closest('[data-opt]'); if (!b || b.disabled || !panel.contains(b)) return;
      const o = b.dataset.opt, v = b.dataset.val;
      if (o === 'g') st.g = +v; else st[o] = v;
      normalize(); sync(); push(false);
    });
    normalize(); sync(); push(false);
    pending = false;   // a kezdő állapotot a betöltés már az adatattribútumokból veszi
  }

  const run = root => (root || document).querySelectorAll('[data-kk3d-cfg]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run()); else run();
  document.addEventListener('shopify:section:load', e => run(e.target));   // témaszerkesztő
  window.KK3DCfg = { run };
})();
